import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { AuthProvider } from "./Components/Data/AuthContext";
import ProtectedRoute from "./Components/routing/ProtectedRoute";
import ErrorBoundary from "./Components/routing/ErrorBoundary";

import SignIN from "./Pages/SignIN";
import SignUP from "./Pages/SignUP";
import DashAdmin from "./Pages/DashAdmin";
import ResetPassword from "./Pages/ResetPassword";
import VerifPage from "./Pages/VerifPage";
import MainPage from "./Pages/dashboard_Pages/MainPage";
import UsersPage from "./Pages/dashboard_Pages/UsersPage";
import ProfilePage from "./Pages/dashboard_Pages/ProfilePage";
import ProgramPage from "./Pages/dashboard_Pages/ProgramNamePage";
import HomePage from "./Pages/homepage";
import Events from "./Pages/eventspage";
import UserProfile from "./Pages/userprofile";
import Layout from "./Components/layout/layout";
import ProgramsPage from "./Pages/ProgramsPage";
import AboutPage from "./Pages/AboutPage";
import ContactPage from "./Pages/ContactPage";
import NotFound from "./Pages/NotFound";
import DonatePage from "./Pages/DonatePage";
import { DonateSuccess, DonateCancelled } from "./Pages/DonateResult";

import "./styles/eduspecial.css";

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/events" element={<Events />} />
              <Route path="/program" element={<ProgramsPage />} />
              <Route path="/programs" element={<ProgramsPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/donate" element={<DonatePage />} />
              {/* Stripe redirects back to these two after checkout. */}
              <Route path="/donate/success" element={<DonateSuccess />} />
              <Route path="/donate/cancelled" element={<DonateCancelled />} />

              <Route path="/signin" element={<SignIN />} />
              <Route path="/signup" element={<SignUP />} />
              <Route path="/emailVerify" element={<VerifPage />} />
              <Route
                path="/reset-password/:userId/:token"
                element={<ResetPassword />}
              />

              <Route
                path="/userprofile"
                element={
                  <ProtectedRoute>
                    <UserProfile />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/AdminDash"
                element={
                  <ProtectedRoute requireAdmin>
                    <DashAdmin />
                  </ProtectedRoute>
                }
              >
                <Route path="mainPage" element={<MainPage />} />
                <Route path="userPage" element={<UsersPage />} />
                <Route path="profilePage" element={<ProfilePage />} />
                <Route path="programPage" element={<ProgramPage />} />
              </Route>

              {/* Header and footer link to these, so an unmatched path must
                  land on a real page rather than an empty shell. */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
